import React, {useState} from "react";
import {Grid} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {MenuButton} from "../../../logistics/purchasing/MenuButton";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {OpeningSizeSubmittal} from "../openingSizeSubmittal/OpeningSizeSubmittal";
import {GlazingSubmittal} from "../glazingSubmittal/GlazingSubmittal";
import {FrameCutPlan} from "../frameCutPlan/FrameCutPlan";

type Submittal = "opening-size" | "glazing" | "frame-cut-plan";

// the submittals generated off the openings grid, other than the shop-drawing one (which keeps its
// own button). Shared by the shop-drawing and quote openings pages — both read the grid the same way.
export function SubmittalsMenu() {
    const [show, setShow] = useState<Submittal | null>(null);

    return (
        <Grid item>
            <MenuButton
                renderButton={p => <SmallGreyButton endIcon={<ArrowDropDownIcon />} {...p} />}
                options={[{
                    name: "Opening Size Submittal",
                    onClick: () => setShow("opening-size"),
                }, {
                    name: "Glazing Submittal",
                    onClick: () => setShow("glazing"),
                }, {
                    name: "Frame Cut Plan",
                    onClick: () => setShow("frame-cut-plan"),
                }]}>Submittals</MenuButton>
            {show === "opening-size" && <OpeningSizeSubmittal onDone={() => setShow(null)} />}
            {show === "glazing" && <GlazingSubmittal onDone={() => setShow(null)} />}
            {show === "frame-cut-plan" && <FrameCutPlan onDone={() => setShow(null)} />}
        </Grid>
    );
}
